import {
	mapGetters
} from 'vuex';

import Activities from '@/domains/agenda/activities/activities/activities';
import HomeworkScheduled from '@/domains/agenda/activities/homework-scheduled/homework-scheduled';
import Restocking from '@/domains/agenda/others/restocking/main';

export default {
	name: 'student-activities',
	components: {
		Activities,
		HomeworkScheduled,
		Restocking
	},
	computed: {
		...mapGetters({
			scheduledHomework: 'getAgendaScheduledHomework'
		})
	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/activities/index.js